/**
 * The root component will contian any global logic, and handle routing (when
 * we need it)
 */

import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { Route, Switch, Redirect } from 'react-router-dom';
import * as MBST from 'mb-components';
import LoginPage from '../../pages/Login';
import ManageGroupsPage from '../../pages/ManageGroups';
import RegisterPage from '../../pages/Register';
import CallbackPage from '../../pages/Callback';
import ManageGroupPage from '../../pages/ManageGroup';
import ForgottenPasswordPage from '../../pages/ForgottenPassword';

const Root = () => {
  const { isAuthenticated } = MBST.useAuth0();
  const query = MBST.useQuery();
  const [service] = useState(query.get('service'));
  const [gradient, setGradient] = useState(true);

  useEffect(() => {
    service ? setGradient(false) : setGradient(true);
  }, [service]);

  return (
    <ThemeProvider theme={MBST.theme}>
      <>
        <MBST.GlobalStyles withGradient={gradient} />
        <MBST.Box
          width="screen"
          height="screen"
          justify="center"
          align="center"
          direction="column"
          overflow="scroll"
        >
          <MBST.Box
            width={'400px'}
            align={'center'}
            justify={service ? 'between' : 'center'}
          >
            {service && (
              <img
                src={`/svg/${service}_logo.svg`}
                alt={service}
                style={{ height: '44px' }}
              />
            )}
            <MBST.Logo size={service ? 'medium' : 'large'} dark={!service} />
          </MBST.Box>
          <MBST.Box
            padding={'6'}
            margin={'6'}
            background={'white'}
            shadow={'lg'}
            radius={'lg'}
            direction={'column'}
            overflow={'scroll'}
            width={{
              min: '400px',
              max: '3/4',
            }}
          >
            <Switch>
              <Route exact path="/" component={LoginPage} />
              <Route exact path="/register" component={RegisterPage} />
              <Route
                exact
                path="/forgotten-password"
                component={ForgottenPasswordPage}
              />
              <Route exact path="/manage-groups">
                {isAuthenticated() ? <ManageGroupsPage /> : <Redirect to="/" />}
              </Route>
              <Route
                path="/manage-group"
                render={({ location }) => (
                  <Redirect
                    to={`/manage-groups/${location.search.split('=')[1]}`}
                  />
                )}
              />
              <Redirect
                from="/manage-group?id=:groupId"
                to="/manage-groups/:groupId"
              />
              <Route exact path="/manage-groups/:groupId">
                {isAuthenticated() ? <ManageGroupPage /> : <Redirect to="/" />}
              </Route>
              <Route path="/callback" component={CallbackPage} />
              <Route component={LoginPage} />
            </Switch>
          </MBST.Box>
        </MBST.Box>
      </>
    </ThemeProvider>
  );
};

export default Root;
